const CURRENT_PRICING_LINK_FAILURE = /(?:cannot be certified against current Pricing|current_pricing_(?:driver_missing|rate_mismatch))/i;

function pricingIssueLabels(error, scope) {
    if (!Array.isArray(error?.pricingIssues) || !Array.isArray(scope)) return [];
    return [...new Set(error.pricingIssues.map(issue => {
        const item = scope[Number(issue?.itemIndex)];
        const category = String(issue?.category || '');
        const sourceKey = category === 'other' ? 'otherCosts' : category;
        const rows = item?.costBreakdown?.[sourceKey];
        const row = Array.isArray(rows) ? rows[Number(issue?.lineIndex)] : null;
        const scopeName = String(item?.title || item?.name || `Scope item ${Number(issue?.itemIndex) + 1}`).trim();
        const lineName = String(
            row?.description || row?.trade || row?.item || row?.name || row?.label || '',
        ).trim();
        return lineName ? `${scopeName}: ${lineName}` : scopeName;
    }).filter(Boolean))].slice(0, 4);
}

/**
 * Convert internal costing certification failures into operator-facing copy.
 * The raw error remains in the developer console, but field paths and internal
 * reason codes do not belong in the customer-facing notification surface.
 */
export function formatCostingRefreshFailure(error, scope = null) {
    const detail = String(error?.message || error || '');
    if (CURRENT_PRICING_LINK_FAILURE.test(detail)) {
        const labels = pricingIssueLabels(error, scope);
        const affected = labels.length > 0 ? ` Affected: ${labels.join('; ')}.` : '';
        return `Costings were not refreshed because some saved lines no longer match current Pricing.${affected} The saved quote and Internal Price Working are unchanged. Close this window, update those lines in Stage 4 Price Working, save them, then refresh saved pricing again.`;
    }
    return 'Costings could not be refreshed. The saved quote and Internal Price Working are unchanged. Review Pricing and try again.';
}
